export default __webpack_public_path__ + "static/media/iconoir_headset-help.2dd8c9b8.svg";